import styled from 'styled-components';

export const SkillsCardContainter = styled.div`
    display: grid;
    grid-template-columns:  repeat(3, 1fr);
    grid-template-rows: auto auto;
    grid-auto-flow: row;
    grid-gap:  1rem;
    padding: 2% 4% 1%;
    justify-content: center; 
    justify-items: center; 
 
       @media(max-width: ${({theme}) => theme.breakpoints.mobile}){
        display: block;
        padding: 0;
    }


`

export const SkillsCard = styled.div`
    min-width: 100px;
    width: 100%;
    min-height: 60px;
    height: 100%;
    border: 2px solid #fff;
    padding: 1.4rem 0;
    border-radius: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${({theme}) => theme.colors.primary_light};
    transition: box-shadow 0.3s ease-in-out; 
    @media(max-width: ${({theme}) => theme.breakpoints.mobile}){
        width: 100%;
        margin-top: 2rem;
    }
            /* Efecto sombra en hover */
    &:hover {
        box-shadow: 8px 8px rgb(255, 255, 255); /* Sombra negra debajo del contorno */
    }

`
